var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
/**
 * Automotive panel widgets — media.
 */
import { registerAutomotive } from '../../registryCore';
import { bool, num, setState, str } from '../../helpers';
import { addAlbumPlaceholder, addMediaArtAndMeta, addPanelFrame, addPanelTitle, addProgressBar, addTransportRow, finishPanel, panelBounds, panelGroup, panelTheme, textAt, } from '../panelPrimitives';
import { fitFontSizeToWidth, fluidFont } from '../../layout';
import { lines } from './shared';
registerAutomotive('nowPlaying', function (props, app) {
    var _a, _b;
    var theme = panelTheme(props);
    var bounds = panelBounds(props, 240, 130);
    var group = panelGroup(app, 'nowPlaying', props, bounds);
    var pad = bounds.pad, w = bounds.innerWidth, h = bounds.innerHeight;
    var rowLines = lines(props, ['Song Title', 'Artist']);
    var title = str(props, 'title', (_a = rowLines[0]) !== null && _a !== void 0 ? _a : 'Song Title');
    var artist = str(props, 'artist', (_b = rowLines[1]) !== null && _b !== void 0 ? _b : 'Artist');
    var progress = num(props, 'progress', 0.42);
    addPanelFrame(group, app, bounds, theme);
    var top = addPanelTitle(group, app, bounds, theme, 'Now Playing');
    addMediaArtAndMeta(group, app, bounds, theme, top, title, artist, '#7c3aed');
    var barY = pad + h - 44;
    addProgressBar(group, app, pad, barY, w, 5, progress, theme);
    addTransportRow(group, app, pad + w / 2, barY + 10, w, pad + h - barY - 12, theme);
    return finishPanel(group, props, bounds, { title: title, artist: artist, progress: progress });
});
registerAutomotive('mediaPlayer', function (props, app) {
    var _a, _b, _c, _d, _e, _f;
    var theme = panelTheme(props);
    var bounds = panelBounds(props, 260, 168);
    var group = panelGroup(app, 'mediaPlayer', props, bounds);
    var pad = bounds.pad, w = bounds.innerWidth, h = bounds.innerHeight;
    var rowLines = lines(props, ['Now playing', 'Track — Artist']);
    var title = str(props, 'title', (_c = (_b = (_a = rowLines[1]) === null || _a === void 0 ? void 0 : _a.split('—')[0]) === null || _b === void 0 ? void 0 : _b.trim()) !== null && _c !== void 0 ? _c : 'Midnight Drive');
    var artist = str(props, 'artist', (_f = (_e = (_d = rowLines[1]) === null || _d === void 0 ? void 0 : _d.split('—')[1]) === null || _e === void 0 ? void 0 : _e.trim()) !== null && _f !== void 0 ? _f : 'Neon Wave');
    var progress = num(props, 'progress', 0.36);
    addPanelFrame(group, app, bounds, theme);
    var top = addPanelTitle(group, app, bounds, theme, 'Media');
    var bottom = addMediaArtAndMeta(group, app, bounds, theme, top, title, artist, '#db2777').bottom;
    var barY = bottom + 10;
    addProgressBar(group, app, pad, barY, w, 6, progress, theme);
    group.add(app.text({ text: '1:24', x: pad, y: textAt(barY - 8, 8), fontSize: 8, fill: theme.textMuted, listening: false }), app.text({ text: '3:42', x: pad + w - 24, y: textAt(barY - 8, 8), fontSize: 8, fill: theme.textMuted, listening: false }));
    addTransportRow(group, app, pad + w / 2, barY + 12, w, pad + h - barY - 14, theme);
    return finishPanel(group, props, bounds, { title: title, artist: artist, progress: progress });
});
registerAutomotive('musicControls', function (props, app) {
    var theme = panelTheme(props);
    var bounds = panelBounds(props, 180, 72);
    var group = panelGroup(app, 'musicControls', props, bounds);
    var pad = bounds.pad, w = bounds.innerWidth, h = bounds.innerHeight;
    addPanelFrame(group, app, bounds, theme, true);
    addTransportRow(group, app, pad + w / 2, pad + 10, w, h - 20, theme, bool(props, 'playing', true));
    return finishPanel(group, props, bounds, { playing: bool(props, 'playing', true) });
});
registerAutomotive('albumArt', function (props, app) {
    var _a;
    var theme = panelTheme(props);
    var bounds = panelBounds(props, 180, 180);
    var group = panelGroup(app, 'albumArt', props, bounds);
    var pad = bounds.pad, w = bounds.innerWidth, h = bounds.innerHeight;
    var rowLines = lines(props, ['[ Artwork ]']);
    var album = str(props, 'album', (_a = rowLines[0]) !== null && _a !== void 0 ? _a : 'Night Roads');
    var artist = str(props, 'artist', 'Neon Wave');
    addPanelFrame(group, app, bounds, theme);
    var art = Math.max(56, Math.min(w, h * 0.58));
    var artX = pad + (w - art) / 2;
    addAlbumPlaceholder(group, app, artX, pad + 8, art, '#4f46e5');
    var metaY = pad + 8 + art + 10;
    group.add(app.text({
        text: album,
        x: pad + w / 2,
        y: textAt(metaY, fluidFont(11, bounds, 9, 13)),
        fontSize: fluidFont(11, bounds, 9, 13),
        fontWeight: 'bold',
        fill: theme.text,
        textAlign: 'center',
        listening: false,
    }), app.text({
        text: artist,
        x: pad + w / 2,
        y: textAt(metaY + 16, 9),
        fontSize: fluidFont(9, bounds, 7, 10),
        fill: theme.textMuted,
        textAlign: 'center',
        listening: false,
    }));
    return finishPanel(group, props, bounds, { album: album, artist: artist });
});
registerAutomotive('fmRadio', function (props, app) {
    var e_1, _a;
    var _b, _c;
    var theme = panelTheme(props);
    var bounds = panelBounds(props, 220, 120);
    var group = panelGroup(app, 'fmRadio', props, bounds);
    var pad = bounds.pad, w = bounds.innerWidth, h = bounds.innerHeight;
    var station = str(props, 'station', (_b = lines(props, ['FM 98.5'])[0]) !== null && _b !== void 0 ? _b : 'FM 98.5');
    var band = str(props, 'band', station.startsWith('AM') ? 'AM' : 'FM');
    var freq = str(props, 'frequency', station.replace(/^(FM|AM)\s*/, '') || '98.5');
    var stationName = str(props, 'stationName', str(props, 'name', 'Classic Hits'));
    var rds = str(props, 'rds', str(props, 'subtitle', 'Neon Wave — Midnight Drive'));
    var stereo = bool(props, 'stereo', true);
    var presets = (_c = props.presets) !== null && _c !== void 0 ? _c : ['88.1', '92.3', '98.5', '101.2'];
    var compact = h < 100;
    addPanelFrame(group, app, bounds, theme, compact);
    var top = addPanelTitle(group, app, bounds, theme, 'Radio');
    if (stereo) {
        group.add(app.text({
            text: 'ST',
            x: pad + w - 18,
            y: textAt(pad + 9, 7),
            fontSize: 7,
            fontWeight: 'bold',
            fill: theme.ok,
            listening: false,
        }), app.circle({
            x: pad + w - 24,
            y: pad + 9,
            radius: 2,
            fill: theme.ok,
            listening: false,
        }));
    }
    var displayY = top + 2;
    var presetH = Math.max(compact ? 18 : 22, Math.min(28, (pad + h - top) * 0.18));
    var presetY = pad + h - presetH;
    var rdsBand = 12;
    var displayH = Math.max(compact ? 58 : 68, presetY - displayY - rdsBand - 6);
    group.add(app.roundedRect({
        x: pad,
        y: displayY,
        width: w,
        height: displayH,
        cornerRadius: 8,
        fill: '#0b1220',
        stroke: theme.dialStroke,
        strokeWidth: 1,
        listening: false,
    }));
    var seek = Math.max(20, Math.min(26, displayH * 0.38));
    var seekY = displayY + (displayH - seek) / 2 - 4;
    var seekL = pad + 6;
    var seekR = pad + w - seek - 6;
    try {
        for (var _d = __values([
            [seekL, "M ".concat(seekL + seek * 0.62, " ").concat(seekY + seek * 0.32, " L ").concat(seekL + seek * 0.28, " ").concat(seekY + seek / 2, " L ").concat(seekL + seek * 0.62, " ").concat(seekY + seek * 0.68)],
            [seekR, "M ".concat(seekR + seek * 0.38, " ").concat(seekY + seek * 0.32, " L ").concat(seekR + seek * 0.72, " ").concat(seekY + seek / 2, " L ").concat(seekR + seek * 0.38, " ").concat(seekY + seek * 0.68)],
        ]), _e = _d.next(); !_e.done; _e = _d.next()) {
            var _f = __read(_e.value, 2), sx = _f[0], path = _f[1];
            group.add(app.roundedRect({
                x: sx,
                y: seekY,
                width: seek,
                height: seek,
                cornerRadius: 6,
                fill: '#1f2937',
                stroke: theme.dialStroke,
                strokeWidth: 1,
                listening: false,
            }), app.path({
                d: path,
                stroke: theme.textMuted,
                strokeWidth: 1.8,
                lineCap: 'round',
                lineJoin: 'round',
                listening: false,
            }));
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
        }
        finally { if (e_1) throw e_1.error; }
    }
    var dialX = pad + w / 2;
    var freqSize = fluidFont(compact ? 22 : 28, bounds, 18, 32);
    var freqY = displayY + displayH * 0.24;
    group.add(app.text({
        text: freq,
        x: dialX,
        y: textAt(freqY, freqSize),
        fontSize: freqSize,
        fontWeight: 'bold',
        fill: theme.text,
        textAlign: 'center',
        listening: false,
    }), app.text({
        text: band,
        x: pad + w - 20,
        y: textAt(displayY + 10, 8),
        fontSize: 8,
        fontWeight: 'bold',
        fill: theme.accent,
        listening: false,
    }));
    var nameSize = fluidFont(9, bounds, 7, 10);
    var nameFit = fitFontSizeToWidth(stationName, w - seek * 2 - 24, nameSize, 7);
    group.add(app.text({
        text: stationName,
        x: dialX,
        y: textAt(displayY + displayH * 0.54, nameFit.fontSize),
        fontSize: nameFit.fontSize,
        fontWeight: 'bold',
        fill: theme.textMuted,
        textAlign: 'center',
        listening: false,
    }));
    var scaleY = displayY + displayH - 6;
    var scaleW = w - 24;
    var scaleX = pad + 12;
    group.add(app.line({
        x: scaleX,
        y: scaleY,
        x2: scaleW,
        y2: 0,
        stroke: '#334155',
        strokeWidth: 1,
        listening: false,
    }));
    for (var i = 0; i <= 10; i++) {
        var tx = scaleX + (scaleW * i) / 10;
        var tall = i % 5 === 0;
        group.add(app.line({
            x: tx,
            y: scaleY,
            x2: 0,
            y2: tall ? -4 : -2,
            stroke: i === 6 ? theme.accent : '#475569',
            strokeWidth: tall ? 1.2 : 0.8,
            listening: false,
        }));
    }
    var rdsSize = fluidFont(8, bounds, 6, 9);
    var rdsText = rds.length > 34 ? "".concat(rds.slice(0, 33), "\u2026") : rds;
    group.add(app.text({
        text: rdsText,
        x: pad + 4,
        y: textAt(displayY + displayH + 8, rdsSize),
        fontSize: rdsSize,
        fill: theme.textMuted,
        listening: false,
    }));
    var pGap = 4;
    var pW = (w - pGap * (presets.length - 1)) / presets.length;
    presets.forEach(function (p, i) {
        var active = p === freq;
        var px = pad + i * (pW + pGap);
        group.add(app.roundedRect({
            x: px,
            y: presetY,
            width: pW,
            height: presetH,
            cornerRadius: 5,
            fill: active ? theme.accent : '#1f2937',
            stroke: active ? theme.accent : theme.dialStroke,
            strokeWidth: 1,
            listening: false,
        }), app.text({
            text: p,
            x: px + pW / 2,
            y: textAt(presetY + presetH / 2, Math.max(8, Math.min(10, pW * 0.28))),
            fontSize: Math.max(8, Math.min(10, pW * 0.28)),
            fontWeight: active ? 'bold' : 'normal',
            fill: active ? '#fff' : theme.textMuted,
            textAlign: 'center',
            listening: false,
        }));
    });
    group.metadata.refresh = function (nextFreq) {
        setState(group, { frequency: String(nextFreq) });
    };
    group.metadata.textRefresh = function (name) { return setState(group, { stationName: name }); };
    return finishPanel(group, props, bounds, {
        station: station,
        band: band,
        frequency: freq,
        stationName: stationName,
        rds: rds,
        stereo: stereo,
        presets: presets,
    });
});
registerAutomotive('podcastPlayer', function (props, app) {
    var _a;
    var theme = panelTheme(props);
    var bounds = panelBounds(props, 240, 130);
    var group = panelGroup(app, 'podcastPlayer', props, bounds);
    var pad = bounds.pad, w = bounds.innerWidth, h = bounds.innerHeight;
    var episode = str(props, 'episode', (_a = lines(props, ['Episode 12'])[0]) !== null && _a !== void 0 ? _a : 'Episode 12');
    var show = str(props, 'show', 'Tech Drive Podcast');
    var progress = num(props, 'progress', 0.58);
    addPanelFrame(group, app, bounds, theme);
    var top = addPanelTitle(group, app, bounds, theme, 'Podcast');
    addMediaArtAndMeta(group, app, bounds, theme, top, show, episode, '#ea580c');
    group.add(app.text({
        text: '1.2×',
        x: pad + w - 28,
        y: textAt(top + 4, 9),
        fontSize: 9,
        fontWeight: 'bold',
        fill: theme.accent,
        listening: false,
    }));
    var barY = pad + h - 44;
    addProgressBar(group, app, pad, barY, w, 5, progress, theme);
    addTransportRow(group, app, pad + w / 2, barY + 10, w, pad + h - barY - 12, theme);
    return finishPanel(group, props, bounds, { episode: episode, show: show, progress: progress });
});
